import React, {
	memo,
	useCallback,
	useMemo
} from 'react';
import PropTypes from 'prop-types';
import {
	Checkbox,
	Form
} from 'semantic-ui-react';

import { log } from '../../services/utils';

import DescriptionTooltip from './DescriptionTooltip';

// props.errors???

const FormCheckbox = ( {
	align = 'left',
	checked,
	fieldLabel,
	inline,
	instructions,
	name,
	onChange,
	readOnly,
	required,
	width,
	...props
} ) => {
	const handleChange = useCallback( (
		e,
		{
			name,
			checked
		}
	) => {
		const target = {
			name,
			value: checked
		};

		onChange( { target } );
	}, [ onChange ] );

	const fieldStyle = useMemo( () => ( {
		display: 'flex',
		flexDirection: 'column',
		alignItems: readOnly
			? 'initial'
			: 'center',
		marginLeft: align === 'right'
			? 'auto'
			: 'initial'
	} ), [ align, readOnly ] );

	const readOnlyStyle = useMemo( () => ( { pointerEvents: 'none' } ), [] );

	return (
		<>
			{ log( `- ${ name } input` ) }
			{ inline
				? <Form.Field
					id={ name }
					required={ !readOnly && required }
					width={ width }
				>
					{ <Checkbox
						label={ <label>{ fieldLabel }{ instructions ? <>&nbsp;&nbsp;<DescriptionTooltip text={ instructions } /></> : null }</label> }
						name={ name }
						onChange={ handleChange }
						readOnly={ readOnly }
						checked={ checked }
						style={ { margin: 'auto 0', ...readOnly && readOnlyStyle } }
						{ ...props }
					/>
					}
				</Form.Field>
				: <Form.Field
					id={ name }
					required={ !readOnly && required }
					style={ fieldStyle }
					width={ width }
				>
					<label>{ fieldLabel }{ instructions ? <>&nbsp;&nbsp;<DescriptionTooltip text={ instructions } /></> : null }</label>
					{ readOnly
						? checked
							? 'Yes'
							: 'No'
						: <Checkbox
							name={ name }
							onChange={ handleChange }
							readOnly={ readOnly }
							checked={ checked }
							style={ { margin: '0 auto', ...readOnly && readOnlyStyle } }
							{ ...props }
						/>
					}
				</Form.Field>
			}
		</>
	);
};

FormCheckbox.propTypes = {
	align: PropTypes.string,
	checked: PropTypes.bool,
	fieldLabel: PropTypes.node.isRequired,
	inline: PropTypes.bool,
	instructions: PropTypes.string,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	readOnly: PropTypes.bool,
	required: PropTypes.bool,
	width: PropTypes.number
};

export default memo( FormCheckbox );
